import { ModeSelector } from '@/components/mode-selector';
import type { ChatSessionIntent } from '../chat-session-intent';

type ChatSpaceSwitcherProps = {
  className?: string;
  onValueChange: (intent: ChatSessionIntent) => void;
  value: ChatSessionIntent;
};

const CHAT_SPACE_OPTIONS = [
  {
    value: 'general' as const,
    label: 'Chat',
  },
  {
    value: 'document-search' as const,
    label: 'RAG',
  },
];

export function ChatSpaceSwitcher({ className, onValueChange, value }: ChatSpaceSwitcherProps) {
  return (
    <ModeSelector
      className={className}
      value={value}
      options={CHAT_SPACE_OPTIONS}
      onValueChange={onValueChange}
      aria-label="Espace conversation"
      data-testid="chat-space-switcher"
      getOptionTestId={(optionValue) =>
        optionValue === 'document-search' ? 'chat-space-rag' : 'chat-space-chat'
      }
    />
  );
}
